import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import homeImage from "../assets/images/home.svg";
import { useDispatch, useSelector } from "react-redux";
import { BlogGetListNews } from "../services/ReduxTookit/Slice/BlogRedux";
import Loader, { LoaderType } from "./common-component/Loader";
import calendar from "../assets/images/calendar.svg";
import { commonservices } from "../services/CommonServices";
import moment from "moment";

const Announcements = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const NewsDataList = useSelector(
    (state) => state?.blogredux?.BlogGetListNewsData?.data?.data?.data || []
  );

  const GetNewsData = useCallback(async () => {
    if (!hasMore || loader) return;
    setLoader(true);
    dispatch(BlogGetListNews({ pagesize: 10, pagenumber: pageNumber }))
      ?.then((response) => {
        if (!response.payload?.data?.length) {
          setHasMore(false); // No more data to load
        }
        setLoader(false);
      })
      .catch(() => setLoader(false));
  }, [dispatch, pageNumber, hasMore, loader]);

  useEffect(() => {
    GetNewsData();
  }, [pageNumber]);
  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 50 >=
      document.documentElement.scrollHeight
    ) {
      setPageNumber((prev) => prev + 1); // Increase page number to fetch more data
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // const [showFull, setShowFull] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});

  const toggleReadMore = (e, id) => {
    e.stopPropagation(); // Prevent navigation
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const shortTextLimit = 200;

  return (
    <div className="projects-page-main all-page-top announcement-list-page">
      <Container>
        <div className="top-bot-section workflow-tab">
          <h6>
            <img
              src={homeImage}
              alt="home"
              title="home"
              style={{ cursor: "pointer", marginBottom: "3px" }}
              onClick={() => navigate("/")}
            />
            <span style={{ fontWeight: "400", color: "#666666" }}>{" | "}</span>
            <span className="mt-1">Announcements</span>
          </h6>
        </div>
        <div className="announcement-list">
          {/* <div className="datafactory-dashboard-data"> */}

          {loader ? (
            <Loader type={LoaderType.AllAnnouncements} />
          ) : (
            <>
              {" "}
              {NewsDataList?.map((item, index) => {
                const isLongText =
                  item?.shortdescription?.length > shortTextLimit;
                const isExpanded = expandedItems[item?.latestnewsid]; // use ID to track each
                return (
                  <div className="single-announcement-item h-100" key={index}>
                    <div className="date-box common-white-bg">
                      <span>
                        <b>
                          {moment(
                            commonservices.convertDateToLocal(
                              item?.dateofpublished
                            )
                          ).format("DD")}
                          <sup>
                            {["st", "nd", "rd"][
                              moment(
                                commonservices.convertDateToLocal(
                                  item?.dateofpublished
                                )
                              ).date() - 1
                            ] || "th"}
                          </sup>
                        </b>
                        <br />
                        {moment(
                          commonservices.convertDateToLocal(
                            item?.dateofpublished
                          )
                        ).format("MMM-yyyy")}
                      </span>
                    </div>
                    <div
                      className="single-announcement cursor-pointer common-white-bg"
                      onClick={() => {
                        navigate("/announcement", {
                          state: { id: item?.latestnewsid },
                        });
                      }}
                    >
                      <h3>{item?.title}</h3>
                      <p>
                        {isExpanded || !isLongText
                          ? item?.shortdescription
                          : item?.shortdescription.slice(0, shortTextLimit) +
                            "... "}
                        {isLongText && (
                          <span
                            onClick={(e) =>
                              toggleReadMore(e, item?.latestnewsid)
                            }
                          >
                            {isExpanded ? "Show Less" : "Read More"}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Announcements;
